<!-- managament portfolio -->
<div appScrollAnimation>
  <div class="wrapper">
    <div class="container">
      <div class="portfolio-wrapper">
        <div class="folio-img">
          <img src="assets/images/folioport-img.svg" alt="">
        </div>
        <div class="right-part">
          <p class="labels font-16">{{"coming" | translate}}</p>
          <h2 class="heading">{{"portfolio Management" | translate}}</h2>
          <div class="port-para">
            <p class="para1">
              {{"folio-para" | translate}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>